import { useCallback } from 'react'
import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { GET_IP_LOG } from 'queries/users'
import { findAllIpLog, findAllIpLogVariables } from '__generatedTypes__/findAllIpLog'
import { DeviceTypeEnum } from '__generatedTypes__/globalTypes'

type Filters = {
  isMobileAppSelected: boolean
  isWebSelected: boolean
}

const getDeviceTypeParam = (filters: Partial<Filters>): DeviceTypeEnum | undefined => {
  if (filters.isWebSelected === filters.isMobileAppSelected) {
    return undefined
  }

  if (filters.isMobileAppSelected) {
    return DeviceTypeEnum.Mobile
  }

  return DeviceTypeEnum.Desktop
}

export const castParams =
  (userId: string) =>
  ({ page, take, filters }: Params<Filters>): findAllIpLogVariables => ({
    query: {
      skip: (page - 1) * take,
      take,
      where: {
        user: {
          id: userId,
        },
        deviceType: getDeviceTypeParam(filters),
      },
    },
  })

export function useIpLogs(userId: string) {
  const castParamsCb = useCallback(castParams(userId), [userId])

  return useQueryWithParams<findAllIpLog, findAllIpLogVariables, 'findAllIpLog', 'items', 'count', Filters>(
    GET_IP_LOG,
    'findAllIpLog',
    'items',
    'count',
    castParamsCb,
    undefined,
    {
      fetchPolicy: 'network-only',
    }
  )
}
